import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import DeleteClass from "../../../Controllers/Admin/ClassAndCourses/DeleteClass";
import GetAllClasses from "../../../Controllers/Admin/ClassAndCourses/GetAllClasses";
import GetUser from "../../../Controllers/Users/GetUser";

export default function ClassesAndCoursesViewModel() {
  const [AuthUser, setAuthUser] = useState();
  const [SchoolID, setSchoolID] = useState("");
  const [ClassesArray, setClassesArray] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const ClassesData = await GetAllClasses(SchoolID);
      setClassesArray(ClassesData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [ClassID, setClassID] = useState("");

  const handleOpenDeleteDialog = (id) => {
    setClassID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteClass(ClassID);
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  // Class Card Dropdown Start
  const [OpenDropdown, setOpenDropdown] = useState(); // undefined is nothing open
  const toggle = (id) => setOpenDropdown(OpenDropdown === id ? undefined : id); // close if currently open
  // Class Card Dropdown End

  return [
    ClassesArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AuthUser,
    IsLoading,
  ];
}
